import { useEffect, useMemo, useState } from 'react';
import type { TimeLeft } from '../utils/promo';

/** Cuenta regresiva hacia una fecha fija. Devuelve null si no hay fecha o si ya terminó. */
export function useCountdown(endAt: string | null): TimeLeft | null {
  const target = useMemo(() => (endAt ? new Date(endAt).getTime() : Number.NaN), [endAt]);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (Number.isNaN(target)) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [target]);

  if (Number.isNaN(target)) return null;
  const diff = Math.floor((target - now) / 1000);
  if (diff <= 0) return null;

  return {
    days: Math.floor(diff / 86400),
    hours: Math.floor((diff % 86400) / 3600),
    minutes: Math.floor((diff % 3600) / 60),
    seconds: diff % 60,
  };
}
